import { render } from "./Employee.vue?vue&type=template&id=99530120&scoped=true"
import script from "./Employee.vue?vue&type=script&lang=js"
export * from "./Employee.vue?vue&type=script&lang=js"

import "./Employee.vue?vue&type=style&index=0&id=99530120&scoped=true&lang=css"
import "./Employee.vue?vue&type=style&index=1&id=99530120&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99530120"]])

export default __exports__